import { PushTokenRegistrationPayload } from '@connect-x-app/shared-domain-models';
import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils';

export const updateFcmToken = (payload: PushTokenRegistrationPayload): Promise<void> =>
  HttpClient.post(API_FACTORY.v4('users/fcm-token'), payload);
